import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import className from "classnames";
import Eyebrow from "../../elements/Eyebrow";
import Standfirst from "../Standfirst";
import getClassNameFactory from "../../utilities/classNames";
import { HeaderAlignments } from "./HeaderTypes";

var Header = function Header(_ref) {
  var align = _ref.align,
      callToAction = _ref.callToAction,
      eyebrow = _ref.eyebrow,
      heading = _ref.heading,
      standfirst = _ref.standfirst;
  var getClassName = getClassNameFactory(Header.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: className(_defineProperty({}, align, align !== HeaderAlignments.LEFT))
    })
  }, eyebrow && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "eyebrow"
    })
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrow
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "heading"
    })
  }, heading), standfirst && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "standfirst"
    })
  }, /*#__PURE__*/React.createElement(Standfirst, null, standfirst)), callToAction && /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "callToAction"
    })
  }, callToAction));
};

Header.alignments = HeaderAlignments;
Header.defaultProps = {
  align: HeaderAlignments.LEFT
};
Header.displayName = "Header";
export default Header;